import { render, staticRenderFns } from "./item-management.vue?vue&type=template&id=7a8dcad4&scoped=true&lang=html"
import script from "./item-management.vue?vue&type=script&lang=js"
export * from "./item-management.vue?vue&type=script&lang=js"
import style0 from "./item-management.vue?vue&type=style&index=0&id=7a8dcad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8dcad4",
  null
  
)

export default component.exports